import React from 'react';
import { Route } from "react-router-dom";
import AppLogout from '../../common/isLogout';
import { PrivateRoute } from '../../common/PrivateRoutes';
import TutorialTroublesooting from '../../Pages/TutorialTroublesooting';
import AddContent from '../../Pages/AddContent';
import ModuleList from '../../Pages/ModuleList';
import AddModule from '../../Pages/AddModule';
import DashboardLayout from '../../Layouts/DashboardLayouts';

const TrainingRoutes2w = () => (
  <>
    {/* 2W Training feature - reuses existing components with conditional logic */}
    <Route element={<AppLogout><PrivateRoute><DashboardLayout /></PrivateRoute></AppLogout>}>
      <Route exact path="/2w/training/list" element={<AppLogout><PrivateRoute><TutorialTroublesooting /></PrivateRoute></AppLogout>} />
      <Route exact path="/2w/training/addcontent" element={<AppLogout><PrivateRoute><AddContent /></PrivateRoute></AppLogout>} />
      <Route exact path="/2w/training/modules/list" element={<AppLogout><PrivateRoute><ModuleList /></PrivateRoute></AppLogout>} />
      <Route exact path="/2w/training/addmodules" element={<AppLogout><PrivateRoute><AddModule /></PrivateRoute></AppLogout>} />
      <Route exact path="/2w/training/editmodules/:id" element={<AppLogout><PrivateRoute><AddModule /></PrivateRoute></AppLogout>} />
    </Route>
  </>
);

export default TrainingRoutes2w;
